import { useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export const useSafeLocalStorage = (key, initialValue, shouldUseLocalStorage) => {
    const testAndSetTimestampWasSuccessful = ((isRetry) => {
        try {
            const testKey = "__test__";
            window.localStorage.setItem(testKey, "__test__");
            window.localStorage.removeItem(testKey);

            const timeStamp = new Date().toISOString();

            if (!window.localStorage.getItem(`${key}-createdAt`)) {
                window.localStorage.setItem(`${key}-createdAt`, timeStamp);
            }
            return true;
        } catch (error) {
            if (error.name === "QuotaExceededError" && !isRetry) {
                console.warn("QuotaExceededError: Local storage is full. Falling back to in-memory storage.");
                cleanLocalStorage();
                testAndSetTimestampWasSuccessful(true);
            }
            return false;
        }
    });

    const cleanLocalStorage = () => {
        Object.keys(window.localStorage).forEach((localStorageName) => {
            if (localStorageName.startsWith('nps-survey') && localStorageName.endsWith('-createdAt')) {
                const localStorageCreatedAt = window.localStorage.getItem(localStorageName);
                const localStorage = localStorageName.replace('-createdAt', '');
                if (localStorageCreatedAt && new Date(localStorageCreatedAt) < new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)) {
                    window.localStorage.removeItem(localStorage);
                    window.localStorage.removeItem(localStorageName);;
                }
            }
        });
    }

    const isLocalStorageAvailable = (() => {
        return shouldUseLocalStorage && testAndSetTimestampWasSuccessful();
    })();

    const [localStorageValue, setLocalStorageValue] = useLocalStorage(key, initialValue);
    const [fallbackValue, setFallbackValue] = useState(initialValue);

    if (isLocalStorageAvailable) {
        return [localStorageValue, setLocalStorageValue];
    } else {
        console.warn(`localStorage is unavailable or not allowed. Using fallback state for key "${key}".`);
        window.localStorage.removeItem(key);
        window.localStorage.removeItem(`${key}-createdAt`);
        const setValue = (value) => {
            const valueToStore = value instanceof Function ? value(fallbackValue) : value;
            setFallbackValue(valueToStore);
        };
        return [fallbackValue, setValue];
    }
};